// Trata a volta do OAuth na URL: ?selecionar=<pendente> (escolher conta), ?conectado=<id>, ?erro=<código>.
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { errorMessage } from '../../lib/api'
import { useToast } from '../../ui/toast'
import { usePendingSelection, useSelectAccount } from './api'
import { oauthErrorMessage } from './oauthErrors'
import SelectAccountDialog from './SelectAccountDialog'

export default function OAuthReturn({ companyId }: { companyId: string }) {
  const [params, setParams] = useSearchParams()
  const notify = useToast()
  const pendingId = params.get('selecionar')
  const [error, setError] = useState<string | null>(oauthErrorMessage(params.get('erro')))
  const pending = usePendingSelection(companyId, pendingId)
  const select = useSelectAccount(companyId, pendingId)

  const clear = (...keys: string[]) => {
    const next = new URLSearchParams(params)
    keys.forEach((k) => next.delete(k))
    setParams(next, { replace: true })
  }

  useEffect(() => {
    if (params.get('conectado')) {
      notify('Conta conectada! Estamos trazendo os últimos 13 meses de dados.')
      clear('conectado')
    }
    if (params.get('erro')) {
      setError(oauthErrorMessage(params.get('erro')))
      clear('erro')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  return (
    <>
      {error && (
        <div className="form-error row between" role="alert" style={{ gap: 8 }}>
          <span>{error}</span>
          <button className="btn ghost sm" onClick={() => setError(null)}>Fechar</button>
        </div>
      )}
      {pendingId && (
        <SelectAccountDialog
          pending={pending.data}
          loading={pending.isLoading}
          error={pending.error}
          submitting={select.isPending}
          submitError={select.error ? errorMessage(select.error) : null}
          onClose={() => clear('selecionar')}
          onSelect={(id) =>
            select.mutate(id, {
              onSuccess: () => {
                notify('Conta conectada! Estamos trazendo os últimos 13 meses de dados.')
                clear('selecionar')
              },
            })
          }
        />
      )}
    </>
  )
}
